import React from 'react';

export default React.createContext({
  session: null,
  update: null,
  reload: null,
  loading: false,
  complete: false
});